import { Box } from '@/shared/components/box'
import { Typography, Tooltip } from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { FiHelpCircle } from 'react-icons/fi'

export const DashboardCard = ({
  title,
  subtitle,
  value,
  tooltipTitle,
  tooltipDescription
}) => {
  const tooltipRef = useRef()
  return (
    <Box className='w-full flex flex-col justify-between'>
      <div className='flex flex-col'>
        <div className='flex gap-1'>
          <Typography className='w-fit text-gray-600 text-sm font-medium self-end'>
            {title}
          </Typography>
          <Tooltip
            ref={tooltipRef}
            className='bg-blue-600'
            placement='top-start'
            content={
              <div className='w-80'>
                <Typography className='font-medium'>
                  {tooltipTitle}
                </Typography>
                <Typography
                  variant='small'
                  color='white'
                  className='font-normal opacity-80'
                >
                  {tooltipDescription}
                </Typography>
              </div>
            }
          >
            <div ref={tooltipRef}>
              <FiHelpCircle className='text-xl w-4 text-gray-400 mt-1' />
            </div>
          </Tooltip>
        </div>
        <Typography className='text-gray-400 text-xs'>
          {subtitle}
        </Typography>
      </div>

      <Typography className='text-black text-4xl font-semibold'>
        {value}
      </Typography>
    </Box>
  )
}

DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.string.isRequired,
  tooltipDescription: PropTypes.string.isRequired
}

DashboardCard.defaultProps = {
  title: '',
  subtitle: '',
  value: '',
  tooltipTitle: '',
  tooltipDescription: ''
}
